<template>
  <div>
    <v-app-bar :color="topBarColor" dark>
      <v-img
        :src="require('../assets/drmms-logo.png')"
        class="shrink mr-1"
        contain
        transition="scale-transition"
        width="60"
        lazy-src="../assets/drmms-logo.png"
      />
      <v-toolbar-title class="mr-6">
        DRMMS 
      </v-toolbar-title>

      <v-divider vertical></v-divider>

      <span class="hidden-lg-and-up">
        <v-btn @click.stop="drawer = !drawer" color="indigo" depressed="">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </span>

      <v-toolbar-items class="hidden-md-and-down ml-6">
         <v-btn v-if="loggedInPosition == 'Admin'" to="/dashboard" text class="no-background-hover">
          <v-icon small left>mdi-office-building-outline</v-icon>
          Dashboard
        </v-btn>
        <v-btn v-if="loggedInPosition == 'Admin'" to="/offices" text class="no-background-hover">
          <v-icon small left>mdi-office-building-outline</v-icon>
          Offices
        </v-btn>
        <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Records Officer' " to="/users" text class="no-background-hover">
          <v-icon small left>mdi-account</v-icon>
          Users
        </v-btn>
        <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Regional Employee' || loggedInPosition == 'Office Head'" to="/routes" text class="no-background-hover">
          <v-icon small left>mdi-routes</v-icon>
          Routes
        </v-btn>
        <v-btn v-if="loggedInPosition == 'Admin'" to="/records" text class="no-background-hover">
          <v-icon small left>mdi-book-open-variant</v-icon>
          Records
        </v-btn>
        <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Regional Employee'" to="/documents" text class="no-background-hover">
          <v-icon small left>mdi-file-document</v-icon>
          Documents
        </v-btn>
        <!-- <v-btn v-if="loggedInPosition == 'Admin'" to="/actions" text class="no-background-hover">
          <v-icon small left>mdi-scatter-plot</v-icon>
          Actions
        </v-btn> -->
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-card class="mx-auto" :color="topBarColor" flat>
            <v-card-subtitle class="pb-0" style="padding:10px; color: #FFFFFF; text-align: right">
              <span style="font-size: 18px; text-color: #FFFFFF" class="mt-5"
                >Welcome, {{ loggedInUserName }}
              </span>
            </v-card-subtitle>
            <v-card-text style="padding: 0px 10px; color: #FFFFFF; text-align: right">
              <div>{{loggedInOffice}} - {{loggedInPosition}}</div>
            </v-card-text>
        </v-card>
        <v-menu offset-y class="mr-5">
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              overlap
              class="mt-4 no-background-hover"
              color="red"
              :value="getUnviewedMentions.length"
              :content="getUnviewedMentions.length"
            >
              <v-btn
                class="no-background-hover mt-n3"
                text
                fab
                v-bind="attrs"
                v-on="on"
                :disabled="isFetching"
              >
                <v-icon >mdi-bell </v-icon>
                <ReusableBadge v-show="!isFetching" :count="notifications.length"/>
                
                <v-progress-circular
                  v-show="isFetching"
                  class="ml-n7"
                  indeterminate
                  color="red"
                ></v-progress-circular>
              </v-btn>
            </v-badge>
          </template>
          <v-list three-line v-if="getUserMentions.length > 0">
            <template v-for="(item, index) in getUserMentions">
              <v-divider
                v-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-item v-else :key="item.title">
                <v-list-item-avatar>
                  <v-avatar color="primary"></v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ item.user }}</v-list-item-title>
                  <v-list-item-subtitle
                    v-html="item.msg"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-list three-line v-else >
            <div v-if="notifications.length > 0">
              <template v-for="(item, index) in notifications">
                <a class="notification-item" style="text-decoration: none" :href="item.link" target="_blank" :key="index">
                  <v-list-item  style="min-height: 44px">
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <b>{{item.date}}</b> {{item.message}} <a style="text-decoration: none" :href="item.link" target="_blank">{{item.button}}</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </a>
                <v-divider
                    v-if="index < notifications.length - 1"
                    :key="index + 20"
                  ></v-divider>
              </template>
            </div>
            <div v-else>
              <template>
                <v-list-item style="min-height: 44px">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      No notifications found.
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>
          </v-list>
        </v-menu>
        <v-btn to="/logout" text class="no-background-hover">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary right>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import moment from 'moment'
  import ReusableBadge from './Badge.vue'
  export default {
    props: ["on", "attrs"],
    components: {
      ReusableBadge
    },
    data() {
      return {
        isFetching: false,
        drawer: false,
        subroute_statuses_for_user: [],
        subroute_without_subroute_statuses: [],
        delegated_routes_almost_due: [],
        items: [
          {
            title: "Dashboard",
            link: "/dashboard",
            icon: "mdi-office-building-outline",
          },
          {
            title: "Offices",
            link: "/offices",
            icon: "mdi-office-building-outline",
          },
          { title: "Users", link: "/users", icon: "mdi-account" },
          { title: "Routes", link: "/routes", icon: "mdi-routes" },
          { title: "Records", link: "/records", icon: "mdi-book-open-variant" },
          { title: "Documents", link: "/documents", icon: "mdi-file-document" },
          { title: "Actions", link: "/actions", icon: "mdi-scatter-plot" },
          { title: "Logout", link: "/logout", icon: "mdi-logout" },
        ],
        notifications: []
      };
    },
    methods: {
      ...mapActions(["fetchRegionalDirectorNotifications","fetchUsers","fetchTags", "viewUserTags", "fetchPendingInitiateDocuments", "fetchRejectedDocuments", "fetchAssignedSubRoutesById"]),
      viewMentions() {
        this.viewUserTags();
      },
      async fetch(){
        this.isFetching = true
        //for all regional director notification
        if(this.loggedInPosition == 'Records Officer')
          await this.fetchRejectedDocuments()
        
        //for all records officer notification
        if(this.loggedInPosition == 'Regional Director'){
          await this.fetchRegionalDirectorNotifications(this.loggedInUserID)
          await this.fetchPendingInitiateDocuments()
        }
        //for all user notification
        await this.fetchTags();
        this.delegated_routes_almost_due = []
        this.subroute_statuses_for_user = []
        this.subroute_without_subroute_statuses = []
        if(this.loggedInPosition !== 'Regional Director' && this.loggedInPosition !== 'Records Officer'){
          await this.fetchUsers({ itemsPerPage: 0 })
          await this.fetchAssignedSubRoutesById(this.loggedInUserID).then(()=>{
            this.getNotificationSubRoutes.forEach(subroute => {
              if(subroute.subroute_status.length !== 0){
                if(subroute.subroute_status[subroute.subroute_status.length - 1].confirm_status !== "pending")
                  this.subroute_statuses_for_user.push(subroute.subroute_status[subroute.subroute_status.length - 1])
              }
              else{
                this.subroute_without_subroute_statuses.push(subroute)
              }
            })
            this.getDelegatedRoutesWithStatus.forEach(delegated => {
              if(moment(delegated.dateEffectiveUntil).subtract(1, "days") < new Date(moment())){
                this.delegated_routes_almost_due.push(delegated)
              }
            })
            this.getRouteDelegatedUsersWithStatus.forEach(delegated => {
              if(moment(delegated.dateEffectiveUntil).subtract(1, "days") < new Date(moment())){
                this.delegated_routes_almost_due.push(delegated)
              }
            })
          })
        }
        this.isFetching = false
        this.notifications = []
        this.setNotifications()
      },
      formatDate(date){
        return moment(date).format('LLL')
      },
      formatDateFromNow(date){
        return moment(date).fromNow()
      },
      isUpdated(item) {
        return item.reject_remarks ? "and updated" : "" 
      },
      getParentUser(parent_id){
        let subroute = this.getAllSubRoutes.filter(subroute => subroute.id == parent_id)
        return subroute[0].user.first_name + " " + subroute[0].user.middle_name + " " + subroute[0].user.last_name 
      },
      getUser(user_id){
        let user = this.allUsers.filter(user => user.id == user_id)
        return user[0].first_name + " " + user[0].middle_name + " " + user[0].last_name
      },
      setNotifications() {
        let notify_regional_for_initiated_documents = this.allRoutePendingDocuments
        let notify_regional_for_routes_pending_completion = this.getAllRoutesWithPendingCompletion
        let notify_regional_for_route_updates_by_receiver = this.getNotificationRegionalFiltered
        let notify_records_officer_for_rejected_documents = this.allRejectedDocuments
        let notify_user_for_route_completion = this.getAllRouteWithCompletedStatus
        let notify_user_for_route_assignment = this.subroute_without_subroute_statuses
        let notify_user_for_route_updates_by_child_receivers = this.subroute_statuses_for_user
        let notify_user_for_child_routes_updates_by_user = this.getChildRoutesWithStatus
        let notify_user_for_route_delegations = this.getDelegatedRoutesWithStatus
        let notify_user_for_almost_due_delegations = this.delegated_routes_almost_due
        let notify_user_for_idle_routes = this.getAllIdleAssignedRoutes
        let notify_regional_for_idle_routes = this.getIdleRoutes
        let notify_regional_for_idle_subroutes = this.getIdleSubRoutes
        let notify_user_for_idle_child_routes = this.getIdleChildRoutes
        if(this.loggedInPosition == 'Regional Director'){
          notify_regional_for_idle_subroutes.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - ${item.user.first_name} ${item.user.middle_name} ${item.user.last_name} haven't updated his/her assigned route for more than 24 hours`,
              button: 'View Assigned Route',
              link: `/routes/${item.route_id}#${item.id}`
            })
          })
          notify_regional_for_idle_routes.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - Route with subject of ${item.subject} is idle.`,
              button: 'View Route',
              link: `/routes/${item.id}`
            })
          })
          notify_regional_for_initiated_documents.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.route_request_date), 
              message: ` - Records Officer initiated ${this.isUpdated(item)} a ${this.isUpdated(item) ? '': 'new'} document
                      with tracer no. "${item.transaction_id}"`,
              button: 'View Document',
              link: `/routes#${item.id}`
              })
          })
          notify_regional_for_routes_pending_completion.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - Route subject ${item.subject} has overall route status "Complete"
                      is pending for completion`,
              button: 'View Route',
              link: `/routes/${item.id}`
            })
          })
          notify_regional_for_route_updates_by_receiver.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - ${item.user_route_assignment.user.first_name} ${item.user_route_assignment.user.middle_name} ${item.user_route_assignment.user.last_name}
                      updated the route status to "${item.status.name}" with remarks of "${item.remarks}"`,
              button: 'View Assigned Route',
              link: `/routes/${item.user_route_assignment.route_id}#${item.user_route_assignment.id}`
            })
          })
        }
        if(this.loggedInPosition == 'Records Officer'){
          notify_records_officer_for_rejected_documents.forEach(item => {
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - Regional Director rejected the document tracer no. ${item.transaction_id} with remarks of "${item.reject_remarks}"`,
              button: 'View Document',
              link: `/documents#${item.id}`
            })
          })
        }
        
        notify_user_for_route_completion.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.updatedAt),
            message: ` - Regional Director set the status of the route with subject ${item.subject} to "Complete"`,
            button: 'View Route',
            link: `/routes/${item.id}`
          })
        })
        notify_user_for_route_assignment.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.createdAt),
            message: ` - ${item.parent_id ? this.getParentUser(item.parent_id) : "Regional Director"} assigned you to this route with action of "${item.action.name}"`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.id}?init=${item.route_id}` + `${item.parent_id ? `&parent=${item.parent_id}` : ``}`
          })
        })
        notify_user_for_route_updates_by_child_receivers.forEach(item => {
          if(item.confirm_status == `rejected`){
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - ${item.user_route_assignment.parent_id ? this.getParentUser(item.user_route_assignment.parent_id) : "Regional Director"} ${item.confirm_status} the route that you are assigned with remarks of "${item.confirmation_remarks}"`,
              button: 'View Assigned Route',
              link: '/routes/assigned/' + `${item.user_route_assignment.id}?init=${item.user_route_assignment.route_id}` + `${item.user_route_assignment.parent_id ? `&parent=${item.user_route_assignment.parent_id}` : ``}`
            })
          }
          if(item.confirm_status == `confirmed`){
            this.notifications.push({
              date: this.formatDate(item.updatedAt),
              message: ` - ${item.user_route_assignment.parent_id ? this.getParentUser(item.user_route_assignment.parent_id) : "Regional Director"} approved the route that you assigned with remarks of "${item.confirmation_remarks}"`,
              button: 'View Assigned Route',
              link: '/routes/assigned/' + `${item.user_route_assignment.id}?init=${item.user_route_assignment.route_id}` + `${item.user_route_assignment.parent_id ? `&parent=${item.user_route_assignment.parent_id}` : ``}`
            })
          }
        })
        notify_user_for_child_routes_updates_by_user.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.updatedAt),
            message: ` - ${item.user.first_name} ${item.user.middle_name} ${item.user.last_name} updated the route status to "${item.subroute_status[item.subroute_status.length - 1].status.name}" with remarks of "${item.subroute_status[item.subroute_status.length - 1].remarks}"`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.parent_id}?init=${item.route_id}`
          })
        })
        notify_user_for_route_delegations.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.createdAt),
            message: ` - ${item.user_route_assignment.user.first_name} ${item.user_route_assignment.user.middle_name} ${item.user_route_assignment.user.last_name} delegated this route to you with action of "${item.user_route_assignment.action.name}".`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.user_route_assignment.id}?init=${item.user_route_assignment.route_id}` + `${item.user_route_assignment.parent_id ? `&parent=${item.user_route_assignment.parent_id}` : ``}`
          })
        })
        notify_user_for_almost_due_delegations.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.createdAt),
            message: ` - Route delegation is about to end ${this.formatDateFromNow(item.dateEffectiveUntil)}`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.user_route_assignment.id}?init=${item.user_route_assignment.route_id}` + `${item.user_route_assignment.parent_id ? `&parent=${item.user_route_assignment.parent_id}` : ``}`
          })
        })
        notify_user_for_idle_routes.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.updatedAt),
            message: ` - Route is idle for more than 24 hours. Please update`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.id}?init=${item.route_id}` + `${item.parent_id ? `&parent=${item.parent_id}` : ``}`
          })
        })
        notify_user_for_idle_child_routes.forEach(item => {
          this.notifications.push({
            date: this.formatDate(item.updatedAt),
            message: ` - ${this.getUser(item.user_id)} haven't updated his/her assigned route.`,
            button: 'View Assigned Route',
            link: '/routes/assigned/' + `${item.parent_id}?init=${item.route_id}`
          })
        })
        this.notifications.sort((a, b) => {
            let da = new Date(b.date),
                db = new Date(a.date);
            return da - db;
        });
      }
    },
    computed: {
      ...mapGetters([
        "getUserMentions",
        "getUnviewedMentions",
        "loggedInUserName",
        "loggedInPosition",
        "loggedInOffice",
        "allRoutePendingDocuments",
        "allRejectedDocuments",
        "loggedInUserID",
        "getNotificationSubRoutes",
        "getAllSubRoutes",
        "getNotificationRegional",
        "getChildRoutesWithStatus",
        "getDelegatedRoutesWithStatus",
        "getRouteDelegatedUsersWithStatus",
        "getAllRoutesWithPendingCompletion",
        "getAllRouteWithCompletedStatus",
        "getAllIdleAssignedRoutes",
        "getIdleRoutes",
        "getIdleSubRoutes",
        "getIdleChildRoutes", 
        "allUsers"
      ]),
      topBarColor: function() {
        let color = ""
        if(this.loggedInPosition == "Admin")
        color = "#673AB7"
        if(this.loggedInPosition == "Records Officer")
        color = "#546E7A"
        if(this.loggedInPosition == "Regional Director")
        color = "#3F51B5"
        if(this.loggedInPosition == "Regional Employee")
        color = "#3F51B5"
        if(this.loggedInPosition == "Office Head")
        color = "#9C27B0"
        return color
      },
      getNotificationRegionalFiltered() {
        return this.getNotificationRegional.filter(item => item.user_route_assignment.parent_id == null)
      },
    },
    async created () {
      this.fetch()
    }
  };
</script>

<style lang="scss" scoped>
  .no-background-hover::before {
    background-color: transparent !important;
  }

  .notif-item {
    padding-bottom: 10px;
    padding-left: 10px;
    padding-top: 20px;
    border-bottom: 1px solid rgb(187, 187, 187);
    transition: 0.2s;
  }
  .notif-item:hover {
    background-color: #e2e2e2;
  }

  .notifications-item {
    padding-bottom: 10px;
    padding-left: 10px;
    padding-top: 20px;
    border-bottom: 1px solid rgb(187, 187, 187);
    transition: 0.2s;
  }
  .notifications-item:hover {
    background-color: #e2e2e2;
  }

  .mention-msg {
    overflow: auto;
    word-wrap: break-word;
    display: block;
  }
</style>
